import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AdminProtectedRoute = ({
  children,
}) => {
  const {
    admin,
    isAuthenticated,
    loading,
  } = useSelector(
    (state) => state.admin
  );

  // Loading
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        Loading...
      </div>
    );
  }

  // Not Logged In
  if (!isAuthenticated) {
    return (
      <Navigate
        to="/admin/login"
        replace
      />
    );
  }

  // Not Super Admin
  if (
    admin?.role !==
    "SUPER_ADMIN"
  ) {
    return (
      <Navigate
        to="/admin/login"
        replace
      />
    );
  }

  return children;
};

export default AdminProtectedRoute;